import { UiTextTooltip } from 'src/components/UI/TextTooltip';
import { SortDirectionEnum } from 'src/utils/types';
import { createTableColumn } from '../types';

type Options = {
  defaultSortDirection?: SortDirectionEnum;
  useFilter?: boolean;
};

export const tableColumnSupporterFullName = createTableColumn<Options>(
  (title, { defaultSortDirection, useFilter = true, ...other } = {}) => ({
    title,
    className: 'text-left',
    sortPropertyName: 'SupporterFullName',
    defaultSortDirection,
    renderValue: ({ SupporterFullName }) => <UiTextTooltip text={SupporterFullName}>{SupporterFullName}</UiTextTooltip>,
    filter: useFilter
      ? {
          type: 'text',
          propertyName: 'SupporterFullName',
        }
      : undefined,
    ...other,
  })
);
